<template>
  <div class="Bigmap-wrapper" v-if="isPC" v-loading.fullscreen="hideLoading" element-loading-text="正在加载地图。。。">
    <div :class="['bigMapBox', overShow ? 'over' : '']">
      <div class="bg" :style="styleObj" @mousedown="move" ref="carouselContent" id="bg">
        <img src="../../assets/bigMap/bigMapbg.png" alt="" @load="hideLoading = false" style="height: 100%;">

        <div class="dian" v-for="(dian, index) in selectData" :key="index"
          :style="'top:' + (dian.top) / 8640 * 100 + '%;position:absolute;left:' + (dian.left) / 15360 * 100 + '%'">
          <el-popover placement="top-start" width="240" offset="120" trigger="hover">
            <div>
              <p class="name">{{ dian.name }}</p>
              <p class="address">{{ '地址:' + dian.address }}</p>
            </div>
            <i class="dian_icon" v-if="dian.type == 'class1'" slot="reference" @click="handleSit(dian)"><img
                src="../../assets/bigMap/icon_sjgzz.png" alt="" style="width:2vw" class="lie">
              <img src="../../assets/bigMap/01.png" alt="" style="width:2vw" class="hot" v-if="shanshuo">
            </i>
            <i class="dian_icon" v-if="dian.type == 'class2'" slot="reference"><img class="lie"
                src="../../assets/bigMap/icon_yjy.png" alt="" style="width:2vw"> <img src="../../assets/bigMap/02.png"
                alt="" style="width:2vw" class="hot" v-if="shanshuo"></i>
            <i class="dian_icon" v-if="dian.type == 'class3'" slot="reference"><img class="lie"
                src="../../assets/bigMap/icon_jyjd.png" alt="" style="width:2vw"> <img src="../../assets/bigMap/03.png"
                alt="" style="width:2vw" class="hot" v-if="shanshuo"></i>
          </el-popover>

        </div>
        <div class="sitItem" v-for="(dian, index) in selectSit" :key="index"
          :style="'top:' + (dian.top) / 8640 * 100 + '%;position:absolute;left:' + (dian.left) / 15360 * 100 + '%'">
          <el-popover placement="top-start" width="240" offset="120" trigger="hover">
            <div>
              <p class="name">{{ dian.name }}</p>
              <p class="address">{{ '地址:' + dian.address }}</p>
            </div>
            <i class="dian_icon" slot="reference">
              <img src="../../assets/bigMap/01.png" alt="" style="width:2vw">
            </i>
          </el-popover>
        </div>
      </div>

      <div class="bottomBar" v-if="!isPC ? true : showBar">
        <img src="../../assets/bigMap/0.png" alt="">
        <div class="arrow" @click="showBar = false">
          <img src="../../assets/bigMap/5.png" alt="">
        </div>
        <div class="classBox">
          <div class="item" v-for="item in classList" :key="item.id" @click="selectClass(item)">
            <img :src="item.img" alt="" v-show="activeIcon !== item.id">
            <img :src="item.imgActive" alt="" v-show="activeIcon == item.id">
          </div>
        </div>

      </div>
      <div class="arrowUp" @click="showBar = true">
        <img src="../../assets/bigMap/5.png" alt="">
      </div>

    </div>
    <div class="search" v-if="searchShow" style="position:fixed;right:50%;margin-right:-150px;width:300px;top: 60px">
      <el-input v-model="search" clearable="">
        <el-button slot="append" icon="el-icon-search" style="outline:none" @click="searchWord(search)"></el-button>
      </el-input>
    </div>
    <div class="bolckfun" style="position:fixed;top:20px;left:20px;visibility: hidden;">
      <i class="el-icon-zoom-in"></i>
      <el-slider v-model="scaleValue" vertical height="100px" :max="10" :min="1" :show-tooltip="false"
        style="margin:10px 0" @input="changeScale">
      </el-slider>
      <i class="el-icon-zoom-out"></i>
    </div>

  </div>
  <div class="m-page-wrapper Bigmap-wrapper" v-else>
    <div :class="['bigMapBox', 'bigMapBoxM', overShow ? 'over' : '']">
      <div class="bg Mbg" :style="styleObj" @touchstart="moveM" ref="carouselContent" id="bg">
        <img src="../../assets/bigMap/bigMapbg.png" alt="" @load="hideLoading = false" style="height: 100%;">

        <div class="dian" v-for="(dian, index) in selectData" :key="index"
          :style="'top:' + (dian.top) / 8640 * 100 + '%;position:absolute;left:' + (dian.left) / 15360 * 100 + '%'">
          <el-popover placement="top-start" width="240" offset="120" trigger="hover">
            <div>
              <p class="name">{{ dian.name }}</p>
              <p class="address">{{ '地址:' + dian.address }}</p>
            </div>
            <i class="dian_icon" v-if="dian.type == 'class1'" slot="reference" @click="handleSit(dian)"><img
                src="../../assets/bigMap/icon_sjgzz.png" alt="" style="width:2vw" class="lie">
              <img src="../../assets/bigMap/01.png" alt="" style="width:2vw" class="hot" v-if="shanshuo">
            </i>
            <i class="dian_icon" v-if="dian.type == 'class2'" slot="reference"><img class="lie"
                src="../../assets/bigMap/icon_yjy.png" alt="" style="width:2vw"> <img src="../../assets/bigMap/02.png"
                alt="" style="width:2vw" class="hot" v-if="shanshuo"></i>
            <i class="dian_icon" v-if="dian.type == 'class3'" slot="reference"><img class="lie"
                src="../../assets/bigMap/icon_jyjd.png" alt="" style="width:2vw"> <img src="../../assets/bigMap/03.png"
                alt="" style="width:2vw" class="hot" v-if="shanshuo"></i>
          </el-popover>

        </div>
        <div class="sitItem" v-for="(dian, index) in selectSit" :key="index"
          :style="'top:' + (dian.top) / 8640 * 100 + '%;position:absolute;left:' + (dian.left) / 15360 * 100 + '%'">
          <el-popover placement="top-start" width="240" offset="120" trigger="hover">
            <div>
              <p class="name">{{ dian.name }}</p>
              <p class="address">{{ '地址:' + dian.address }}</p>
            </div>
            <i class="dian_icon" slot="reference">
              <img src="../../assets/bigMap/01.png" alt="" style="width:2vw">
            </i>
          </el-popover>
        </div>
      </div>

      <div class="bottomBar" v-if="!isPC ? true : showBar">
        <img src="../../assets/bigMap/0.png" alt="">
        <div class="arrow" @click="showBar = false">
          <img src="../../assets/bigMap/5.png" alt="">
        </div>
        <div class="classBox">
          <div class="item" v-for="item in classList" :key="item.id" @click="selectClass(item)">
            <img :src="item.img" alt="" v-show="activeIcon !== item.id">
            <img :src="item.imgActive" alt="" v-show="activeIcon == item.id">
          </div>
        </div>

      </div>
      <div class="arrowUp" @click="showBar = true">
        <img src="../../assets/bigMap/5.png" alt="">
      </div>

    </div>
    <div class="search" v-if="searchShow" style="position:fixed;right:50%;margin-right:-150px;width:300px;top: 60px">
      <el-input v-model="search" clearable="">
        <el-button slot="append" icon="el-icon-search" style="outline:none" @click="searchWord(search)"></el-button>
      </el-input>
    </div>
    <div class="bolckfun" style="position:fixed;top:35rem;left:20px;visibility: hidden;">
      <i class="el-icon-zoom-in"></i>
      <el-slider v-model="scaleValue" vertical height="100px" :max="10" :min="1" :show-tooltip="false"
        style="margin:10px 0" @input="changeScale">
      </el-slider>
      <i class="el-icon-zoom-out"></i>
    </div>
  </div>

</template>

<script>
import mapData from "@/components/kr/bigMap.json"

export default {
  name: 'PopupBigMap',
  data() {
    return {
      styleObj: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%,-50%)",
        height: "100%",
        whiteSpace: "nowrap",
        display: "inline-block",
        cursor: 'grab',
        overflow: 'auto',
        transformOrigin: '50% 50%',
        border: 'none',
        fontSize: '0',
        // transition:'all .3s'

      },
      hideLoading: true,
      activeIcon: 0,
      mapData: mapData,
      selectData: [],
      carouselEle: null,
      scaleValue: 0,
      showBar: false,
      search: "",
      selectSit: [],
      searchShow: false,
      shanshuo: false,
      overShow: false,
      classList: [
        { id: 1, img: require('../../assets/bigMap/1.png'), imgActive: require('../../assets/bigMap/1-1.png'), type: "class1" },
        { id: 3, img: require('../../assets/bigMap/3.png'), imgActive: require('../../assets/bigMap/3-3.png'), type: "class3" },
        { id: 2, img: require('../../assets/bigMap/2.png'), imgActive: require('../../assets/bigMap/2-2.png'), type: "class2" },

        { id: 4, img: require('../../assets/bigMap/4.png'), imgActive: require('../../assets/bigMap/4-4.png') },
      ]
    }
  },
  mounted() {
    this.initData('class1');

    window.addEventListener('mousewheel', this.handleScroll, true) || window.addEventListener("DOMMouseScroll", this.handleScroll, false)

  },
  methods: {
    // debounce(fn, delay) {
    //   let timer = null //借助闭包
    //   return function () {
    //     if (timer) {
    //       clearTimeout(timer) //进入该分支语句，说明当前正在一个计时过程中，并且又触发了相同事件。所以要取消当前的计时，重新开始计时
    //       timer = setTimeOut(fn, delay)
    //     } else {
    //       timer = setTimeOut(fn, delay) // 进入该分支说明当前并没有在计时，那么就开始一个计时
    //     }
    //   }
    // },

    handleScroll(e) {
      console.log(e)
      if (e.wheelDelta > 0 || e.detail < 0) {
        console.log(1);
        if (this.scaleValue < 10) {
          this.scaleValue++
        }


      } else {
        console.log(2);

        if (this.scaleValue > 1) {
          this.scaleValue--
        }
      }

    },
    selectClass(item) {
      this.shanshuo = false;
      this.selectSit = [];
      if (item.id !== 4) {
        if (this.activeIcon == item.id) {
          this.activeIcon = 0;
          this.initData()
        } else {
          this.activeIcon = item.id;
          this.initData(item.type)



        }
      } else {
        if (this.activeIcon == item.id) {
          this.activeIcon = 0;
          this.initData()
          this.searchShow = false;
        } else {
          this.activeIcon = item.id;
          this.searchShow = true;
        }

      }
      console.log(item.id)


    },
    initData(type) {  // eslint-disable-line no-unused-vars
      if (type) {
        this.selectData = [];
        mapData.map(v => {
          if (v.type == type) {
            this.selectData.push(v);
          }
        })
      } else {
        this.selectData = this.mapData
      }

      console.log(this.selectData)
    },
    handleSit(sit) {
      let data = this.mapData;
      let selectSit = [];
      for (let item of data) {
        if (item.site && (item.site == sit.name)) {
          selectSit.push(item)
        }
      }
      this.selectSit = selectSit;
    },
    searchWord(query) {
      let data = this.mapData;
      let selectData = [];
      this.shanshuo = true;
      this.selectSit = [];
      for (let item of data) {
        if (item.name && item.name.indexOf(query) >= 0) {
          selectData.push(item)
        } else if (item.site && item.site.indexOf(query) >= 0) {
          selectData.push(item)
        }
        else if (item.sitAddress && item.sitAddress.indexOf(query) >= 0) {
          selectData.push(item)
        }
        else if (item.address && item.address.indexOf(query) >= 0) {
          selectData.push(item)
        }
      }
      this.selectData = selectData
    },
    changeScale(scale) {
      console.log(scale, 222);
      // this.styleObj.height = (scale - 1) * 30 + 100 + '%';
      // this.styleObj.top = -(scale - 1) * 5 + '%'


      if (scale > 1) {
        this.styleObj.transform = 'translate(-50%,-50%) scale(' + scale * 0.6 + ',' + scale * 0.6 + ') ';
        this.overShow = true;
      } else {
        this.styleObj.transform = 'translate(-50%,-50%) scale(1) '
      }

    },

    // 拖动图片
    move(e) {
      console.log(e);
      e.preventDefault();
      // 获取元素
      var left = document.querySelector(".bigMapBox");
      var img = document.querySelector(".bg");
      var x = e.pageX - img.offsetLeft;
      var y = e.pageY - img.offsetTop;
      // 添加鼠标移动事件
      left.addEventListener("mousemove", move);
      function move(e) {
        img.style.left = e.pageX - x + "px";
        img.style.top = e.pageY - y + "px";
      }
      // 添加鼠标抬起事件，鼠标抬起，将事件移除
      img.addEventListener("mouseup", function () {
        left.removeEventListener("mousemove", move);
      });
      // 鼠标离开父级元素，把事件移除
      left.addEventListener("mouseout", function () {
        left.removeEventListener("mousemove", move);
      });
    },
    // 拖动图片
    moveM(e) {
      alert(2);
      e.preventDefault();
      // 获取元素
      var left = document.querySelector(".bigMapBoxM");
      var img = document.querySelector(".Mbg");
      var x = e.pageX - img.offsetLeft;
      var y = e.pageY - img.offsetTop;
      alert(left)
      // 添加鼠标移动事件
      left.addEventListener("mousemove", move);
      function move(e) {

        alert(2)
        img.style.left = e.pageX - x + "px";
        img.style.top = e.pageY - y + "px";
      }
      // 添加鼠标抬起事件，鼠标抬起，将事件移除
      img.addEventListener("mouseup", function () {
        // alert(3)
        left.removeEventListener("mousemove", move);
      });
      // 鼠标离开父级元素，把事件移除
      left.addEventListener("mouseout", function () {
        //  alert(4)
        left.removeEventListener("mousemove", move);
      });
    },
    // 缩放图片
    rollImg() {
      /* 获取当前页面的缩放比 若未设置zoom缩放比，则为默认100%，即1，原图大小 */
      // alert(1)
      // var zoom = parseInt(this.$refs.imgDiv.style.zoom) || 100;
      // /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动 */

      // zoom += event.wheelDelta / 12;
      // /* 最小范围 和 最大范围 的图片缩放尺度 */

      // if (zoom >= 80 && zoom < 500) {
      //   this.$refs.imgDiv.style.zoom = zoom + "%";
      // }
      // return false;
    }

  }
}
</script>

<style scoped>
.Bigmap-wrapper {
  width: 100%;
  height: 100%;
  text-align: center;
  color: #ffffff;
}

.bigMapBox {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  /* background-image: url(../../assets/bigMap/bigMapbg.jpg);
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center top; */
  position: relative;
  overflow: hidden;
  /* overflow: auto; */
  text-align: center;
  background-image: url(../../assets/bigMap/bg_map.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border: none
}

.bigMapBox.over {
  /* overflow-y: auto; */
}

.bigMapBox .bg {
  /* background-image: url(../../assets/bigMap/bigMapbg.jpg);
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center top; */

  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  white-space: nowrap;
  display: inline-block;
}

.bigMapBox .bg img {
  height: 100%;
  display: inline-block;
}

.bottomBar {
  width: 800px;
  position: fixed;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.bottomBar img {
  width: 100%;
  transition: all 0.1s ease-in-out;
}

/deep/ .bottomBar .classBox .item {
  width: 100px;
  float: left;
  margin-left: 20px;
  cursor: pointer;
}

/deep/ .bottomBar .classBox .item:hover img {
  transform: scale(1.1);
}

.bottomBar .classBox .item:nth-child(1) {
  width: 115px;
}

/* .bottomBar .classBox .item:nth-child(1) {
  width: 60px;
  margin-top: 40px;
} */

.bottomBar .classBox {
  position: absolute;
  right: 130px;
  top: -70px;
}

.bottomBar .arrow {
  position: absolute;
  top: -20px;
  left: 100px;
  width: 70px;
  cursor: pointer;
}

.dian_icon {
  max-width: 100px;
  cursor: pointer;
}

.dian_icon:hover img {
  transform: scale(1.22);
}

.dian_icon .hot {
  position: absolute;
  top: -2vh;
  left: 50%;
  margin-left: -1vw;
  -webkit-animation-name: flash;
  animation-name: flash;
  transition: all 0.1s ease-in-out;
  -webkit-animation-duration: 1.2s;
  animation-duration: 1.2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

.dian_icon .hot.ani {}

.dian .name {
  font-weight: 600;
  margin: 5px 0;
  font-size: 16px;
}

.dian .address {
  font-size: 14px;
}

.arrowUp {
  position: fixed;
  bottom: 10px;
  left: 50%;
  margin-left: -30px;
  cursor: pointer;
}

.arrowUp img {
  width: 60px;
  transform: rotate(180deg);
}

.arrowUp:hover img {
  transform: rotate(180deg) scale(1.2);
}

@-webkit-keyframes flash {

  /*只用修改这里就可以实现不同动画。例如大小闪烁transform: scale(.9);*/
  0%,
  100%,
  50% {
    opacity: 1;
    transform: scale(1);
  }

  25%,
  75% {
    opacity: 0.2;
    transform: scale(0.9);
  }
}

@keyframes flash {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.2;
    transform: scale(0.9);
  }
}

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #fff;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #1b77ce;
}

.m-page-wrapper .Bigmap-wrapper {
  height: 100vh;
}

.m-page-wrapper .bottomBar {
  width: 100%;
  position: fixed;
  display: block;
}

.m-page-wrapper .bottomBar .classBox {
  width: 100%
}

.m-page-wrapper .bottomBar .classBox .item {
  width: 15%;
  margin: 0;
}

.m-page-wrapper .bottomBar .classBox {
  right: 0;
  display: flex;
  justify-content: space-around;
  top: -130%;
}

.m-page-wrapper .bottomBar .arrow {
  width: 10%;
  left: 10px;
  display: none;
}

/* .m-page-wrapper .bottomBar .arrow img{width: ;} */
.m-page-wrapper .bigMapBox {
  overflow: auto;
}

.m-page-wrapper .bolckfun {
  /* visibility: visible !important; */
}

.m-page-wrapper .arrowUp {
  width: 60px;
  display: none;
}
</style>